/**
 * Centralized theme tokens for the entire app.
 * Import this file in any component to use consistent colors.
 * 
 * Palette: dusty-olive (50–950) + white backgrounds
 * Change tokens here → changes everywhere.
 */

const theme = {
    // ── Page & Layout ──
    pageBg: 'bg-white',
    cardBg: 'bg-white',
    cardBorder: 'border border-olive-200',
    cardShadow: 'shadow-sm',
    cardRound: 'rounded-2xl',
    sectionBg: 'bg-olive-50',

    // ── Text ──
    textPrimary: 'text-olive-900',
    textSecondary: 'text-olive-600',
    textMuted: 'text-olive-400',
    textOnAccent: 'text-white',

    // ── Accent Buttons (primary CTA) ──
    btnPrimary: 'bg-olive-600 text-white hover:bg-olive-700 active:scale-[0.98] transition-all duration-200',
    btnSecondary: 'bg-olive-100 text-olive-700 hover:bg-olive-200 active:scale-[0.98] transition-all duration-200',
    btnDanger: 'bg-red-500 text-white hover:bg-red-600 active:scale-[0.98] transition-all duration-200',
    btnGhost: 'text-olive-600 hover:bg-olive-50 active:scale-[0.98] transition-all duration-200',

    // ── Inputs ──
    input: 'bg-white border border-olive-200 text-olive-900 placeholder-olive-400 rounded-xl focus:outline-none focus:ring-2 focus:ring-olive-300 focus:border-olive-300',

    // ── Pills / Tabs ──
    pillActive: 'bg-olive-600 text-white shadow-sm',
    pillInactive: 'text-olive-500 hover:text-olive-700 hover:bg-olive-50',
    pillContainer: 'bg-olive-50 rounded-xl p-1',

    // ── Table ──
    tableHeader: 'bg-olive-50',
    tableBorder: 'border-olive-100',
    tableRowHover: 'hover:bg-olive-50',
    tableRowAlt: 'bg-olive-50/50',
    tableText: 'text-olive-700',
    tableHeadText: 'text-olive-500',

    // ── Badges / Tags ──
    badge: 'bg-olive-100 text-olive-700',
    badgeActive: 'bg-olive-600 text-white',

    // ── Spinner ──
    spinner: 'border-olive-200 border-t-olive-600',

    // ── Header / Nav ──
    headerBg: 'bg-white/80 backdrop-blur-lg border-b border-olive-200',
    navLink: 'text-olive-600 hover:bg-olive-50 hover:text-olive-800',
    navLinkActive: 'bg-olive-100 text-olive-800',

    // ── Modal ──
    modalOverlay: 'bg-black/20',
    modalBg: 'bg-white rounded-2xl shadow-lg',
};

export default theme;
